import { useState } from 'react';
import { useAdminContext } from '../../../api/AdminContext';
import SelectElement from '../../../components/forms/SelectElement';
import { useLoadingContext } from '../../../context/LoadingContext';
import {
	reportYearOptions,
	userOptions
} from '../../../data/option-objects/examOptions';
import MainSection from '../../../layout/app/dashboard/MainSection';
import { convertFirebaseTSToDateString } from '../../../utils/helpers';
import type { QuestionBankID } from '../../../data/interface-question-bank';
import type { User } from '../../../data/interface-user';

interface Tab {
	id: QuestionBankID;
	name: string;
	href: string;
	current: boolean;
}

const UserReport = () => {
	const { getUserList } = useAdminContext();
	const { setLoading, setLoadingMessage } = useLoadingContext();
	const [targetYear, setTargetYear] = useState<number>(
		Number(reportYearOptions[0].id)
	);
	const [tempUsers, setTempUsers] = useState<User[]>([]);
	const [bankID, setbankID] = useState<QuestionBankID>('enurm');
	const [userType, setUserType] = useState<string>('all');
	const [tabs, setTabs] = useState<Tab[]>([
		{ id: 'enurm', name: 'ENURM', href: '#', current: true },
		{ id: 'maxilofacial', name: 'ENURM-CMF', href: '#', current: false },
		{ id: 'dermatología', name: 'PrepDerm', href: '#', current: false }
		// { id: 'enurm', name: 'Billing', href: '#', current: false }
	]);

	function classNames(...classes: string[]) {
		return classes.filter(Boolean).join(' ');
	}

	const handleUserRequest = () => {
		setLoading(true);
		setLoadingMessage('Cargando lista de usuarios...');
		setTempUsers([]);
		// console.log({ bankID, targetYear });
		getUserList(bankID, targetYear)
			.then((userList) => {
				console.log('User list:', userList);

				if (userType === 'all') {
					setTempUsers(userList);
				} else if (userType === 'paid') {
					setTempUsers(
						userList.filter(
							(user) => user[`membership_${targetYear}`]?.isPaid === true
						)
					);
				} else {
					setTempUsers(
						userList.filter(
							(user) => user[`membership_${targetYear}`]?.isPaid !== true
						)
					);
				}
			})
			.catch((error) => {
				console.error('Error fetching user list:', error);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const handleTabChange = (tabID: QuestionBankID) => {
		setTempUsers([]);
		const newTabs = tabs.map((tab) => {
			if (tab.id === tabID) {
				return { ...tab, current: true };
			} else {
				return { ...tab, current: false };
			}
		});
		setTabs(newTabs);
		setbankID(tabID);
	};

	const handleTabClick = (tabID: QuestionBankID) => () =>
		handleTabChange(tabID);

	function handleUserChange(value: string) {
		setUserType(value);
	}

	return (
		<MainSection title='User Report'>
			<div className='my-8 w-full'>
				<div className='px-4 sm:px-6 lg:px-8'>
					<div className='border-b' id='tabs'>
						<div className='sm:hidden'>
							<div className='flex flex-col'>
								<div>
									<label htmlFor='tabs' className='sr-only'>
										Select a tab
									</label>
									{/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
									<select
										id='tabs'
										name='tabs'
										className='block w-full rounded-md border-gray-300 focus:border-brand-500 focus:ring-brand-500'
										onChange={(e) =>
											handleTabChange(e.target.value as QuestionBankID)
										}
										// defaultValue={
										// tabs?.find((tab: Tab) => tab?.current)?.name ?? ''
										// }
										defaultValue={bankID}>
										{tabs.map((tab) => (
											<option key={tab.id} value={tab.id}>
												{tab.name}
											</option>
										))}
									</select>
								</div>
								<SelectElement
									defaultOption='Tipo de usuario'
									handleChange={handleUserChange}
									icon='ballot'
									iconFam='material-icons'
									id='user-type'
									isLabelHidden={true}
									label='Elige tipo de usuario'
									options={userOptions}
									value={userType}
								/>
								<SelectElement
									defaultOption='Elige un año'
									id='categoryID'
									icon='ballot'
									iconFam='material-icons'
									isLabelHidden={true}
									label='Elige un año'
									options={reportYearOptions}
									value={targetYear.toString()}
									handleChange={(v) => {
										setTargetYear(Number(v));
									}}
								/>
							</div>
						</div>
						<div className='hidden sm:block'>
							<div className='flex justify-between'>
								<nav className='flex space-x-4 w-10/12' aria-label='Tabs'>
									{tabs.map((tab) => (
										<button
											key={tab.id}
											id={tab.id}
											className={classNames(
												tab.current
													? 'bg-brand-100 text-brand-700'
													: 'text-gray-500 hover:text-gray-700',
												'rounded-md px-3 py-2 text-sm font-medium'
											)}
											aria-current={tab.current ? 'page' : undefined}
											onClick={handleTabClick(tab.id)}>
											{tab.name}
										</button>
										// <a
										// key={tab.id}
										// href={tab.href}
										// className={classNames(
										// tab.current
										// ? 'bg-brand-100 text-brand-700'
										// : 'text-gray-500 hover:text-gray-700',
										// 'rounded-md px-3 py-2 text-sm font-medium'
										// )}
										// aria-current={tab.current ? 'page' : undefined}>
										// {tab.name}
										// </a>
									))}
								</nav>
								<div className='flex align-items-center'>
									<SelectElement
										defaultOption='Tipo de usuario'
										id='user-type'
										icon='ballot'
										iconFam='material-icons'
										isLabelHidden={true}
										label='Elige tipo de usuario'
										options={userOptions}
										parentClass='mr-2'
										value={userType}
										handleChange={handleUserChange}
									/>
									<SelectElement
										defaultOption='Elige un año'
										id='categoryID'
										icon='ballot'
										iconFam='material-icons'
										isLabelHidden={true}
										label='Elige un año'
										options={reportYearOptions}
										parentClass='2'
										value={targetYear.toString()}
										handleChange={(v) => {
											setTargetYear(Number(v));
										}}
									/>
								</div>
							</div>
						</div>
					</div>

					<div id='description' className='sm:flex sm:items-center'>
						<div className='sm:flex-auto'>
							<h1 className='text-base font-semibold leading-6 text-gray-900'>
								All Users
							</h1>
							<p className='mt-2 text-sm text-gray-700'>
								A list of all the users in our system account including their
								name, membership status, email and sign up date.
							</p>
						</div>
						<div className='mt-4 sm:ml-16 sm:mt-0 sm:flex-none'>
							<button
								type='button'
								onClick={handleUserRequest}
								className='block rounded-md bg-brand-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-brand-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600'>
								Get users
							</button>
						</div>
					</div>

					{tempUsers.length > 0 && (
						<div className='mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3'>
							{/* Total Users */}
							<div className='bg-white rounded-lg border border-gray-200 p-4 shadow-sm'>
								<div className='flex items-center'>
									<div className='flex-shrink-0'>
										<div className='w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center'>
											<svg
												className='w-5 h-5 text-blue-600'
												fill='none'
												stroke='currentColor'
												viewBox='0 0 24 24'>
												<path
													strokeLinecap='round'
													strokeLinejoin='round'
													strokeWidth={2}
													d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
												/>
											</svg>
										</div>
									</div>
									<div className='ml-4'>
										<p className='text-sm font-medium text-gray-500 mb-0'>
											Total Users
										</p>
										<p className='text-2xl font-bold text-gray-900 mb-0'>
											{tempUsers.length}
										</p>
									</div>
								</div>
							</div>

							{/* Paid Users */}
							<div className='bg-white rounded-lg border border-gray-200 p-4 shadow-sm'>
								<div className='flex items-center'>
									<div className='flex-shrink-0'>
										<div className='w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center'>
											<svg
												className='w-5 h-5 text-green-600'
												fill='none'
												stroke='currentColor'
												viewBox='0 0 24 24'>
												<path
													strokeLinecap='round'
													strokeLinejoin='round'
													strokeWidth={2}
													d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
												/>
											</svg>
										</div>
									</div>
									<div className='ml-4'>
										<p className='text-sm font-medium text-gray-500 mb-0'>
											Paid Users
										</p>
										<p className='text-2xl font-bold text-gray-900 mb-0'>
											{
												tempUsers.filter(
													(user) =>
														user[`membership_${targetYear}`]?.isPaid === true
												).length
											}
										</p>
									</div>
								</div>
							</div>

							{/* Unpaid Users */}
							<div className='bg-white rounded-lg border border-gray-200 p-4 shadow-sm'>
								<div className='flex items-center'>
									<div className='flex-shrink-0'>
										<div className='w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center'>
											<svg
												className='w-5 h-5 text-red-600'
												fill='none'
												stroke='currentColor'
												viewBox='0 0 24 24'>
												<path
													strokeLinecap='round'
													strokeLinejoin='round'
													strokeWidth={2}
													d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
												/>
											</svg>
										</div>
									</div>
									<div className='ml-4'>
										<p className='text-sm font-medium text-gray-500 mb-0'>
											Unpaid Users
										</p>
										<p className='text-2xl font-bold text-gray-900 mb-0'>
											{
												tempUsers.filter(
													(user) =>
														user[`membership_${targetYear}`]?.isPaid !== true
												).length
											}
										</p>
									</div>
								</div>
							</div>
						</div>
					)}

					<div id='table' className='mt-8 flow-root'>
						<div className='-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8'>
							<div className='inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8'>
								<table className='min-w-full divide-y divide-gray-300'>
									<thead>
										<tr>
											<th
												scope='col'
												className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0'>
												UserID
											</th>
											<th
												scope='col'
												className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0'>
												FirstName
											</th>
											<th
												scope='col'
												className='hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell'>
												MiddleName
											</th>
											<th
												scope='col'
												className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0'>
												LastName
											</th>
											<th
												scope='col'
												className='hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell'>
												SecondLastName
											</th>
											<th
												scope='col'
												className='hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell'>
												Email
											</th>
											<th
												scope='col'
												className='hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell'>
												Cedula
											</th>
											<th
												scope='col'
												className='hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell'>
												Signup
											</th>
											<th
												scope='col'
												className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900'>
												Customer
											</th>
											<th
												scope='col'
												className='hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell'>
												Exam Target
											</th>
											<th
												scope='col'
												className='relative py-3.5 pl-3 pr-4 sm:pr-0'>
												<span className='sr-only'>Edit</span>
											</th>
										</tr>
									</thead>
									<tbody className='divide-y divide-gray-200'>
										{tempUsers !== undefined &&
											tempUsers.length > 0 &&
											tempUsers.map((user: User) => (
												<tr key={user.id}>
													<td className='whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0'>
														{user?.uid}
													</td>
													<td className='whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0'>
														{user?.person?.firstName}
													</td>
													<td className='hidden whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:table-cell sm:pl-0'>
														{user?.person?.middleName}
													</td>
													<td className='whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0'>
														{user?.person?.lastName}
													</td>
													<td className='hidden whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 lg:table-cell sm:pl-0'>
														{user?.person?.secondLastName}
													</td>
													<td className='hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell'>
														{user.email}
													</td>
													<td className='hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell'>
														{user?.person?.cedula}
													</td>
													<td className='hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell'>
														{convertFirebaseTSToDateString(user.signUpDate)}
													</td>
													<td className='whitespace-nowrap px-3 py-4 text-sm text-gray-500'>
														{user[`membership_${targetYear}`]?.isPaid ?? false
															? 'Paid'
															: ''}
														{/* // TODO:  */}
													</td>
													<td className='hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell'>
														{user.examTarget?.toUpperCase() ?? ''}
													</td>
													<td className='relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0'>
														{/* // TODO: Add edit functionality */}
														{/* <a
													href='#'
													className='text-brand-600 hover:text-brand-900'>
													Edit
													<span className='sr-only'>, {user.person.name}</span>
												</a> */}
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</MainSection>
	);
};
export default UserReport;
